export enum IndicatorCodes {
  CO2 = 'CO',
  Energie = 'EN',
  TonneKilometre = 'TK',
  NaturalAggregaes = 'GN',
  ReclaimedAsphalt = 'AE',
  SoildReused = 'DRC',
  RecycledMaterials = 'MR'
}
